import React from 'react';
import { Bell, ShieldCheck, Clock, Plus, Home, FileText, Activity, User } from 'lucide-react';
interface ScreenProps {
  onNavigate: (screenId: number) => void;
}
export function Screen2({
  onNavigate
}: ScreenProps) {
  return <div className="min-h-full bg-slate-50 flex flex-col pb-20" data-id="element-38">
      {/* Header */}
      <div className="px-6 pt-6 pb-4 bg-white" data-id="element-39">
        <div className="flex items-center justify-between mb-6" data-id="element-40">
          <div data-id="element-41">
            <p className="text-xs text-slate-500 mb-0.5" data-id="element-42">Welcome,</p>
            <h1 className="text-xl font-bold text-datmont-900" data-id="element-43">Isaac Daniel</h1>
          </div>
          <button className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 relative" data-id="element-44">
            <Bell className="w-5 h-5" data-id="element-45" />
            <span className="absolute top-2.5 right-2.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white" data-id="element-46"></span>
          </button>
        </div>
      </div>

      <div className="flex-1 px-6 py-4 space-y-6" data-id="element-47">
        {/* Verified Documents Section */}
        <div data-id="element-48">
          <div className="flex items-center gap-2 mb-4" data-id="element-49">
            <div className="w-6 h-6 rounded-full bg-datmont-900 flex items-center justify-center" data-id="element-50">
              <ShieldCheck className="w-3.5 h-3.5 text-white" data-id="element-51" />
            </div>
            <h2 className="text-sm font-bold text-datmont-900" data-id="element-52">
              Verified Documents
            </h2>
          </div>

          <div className="space-y-3 bg-white p-4 rounded-2xl border border-slate-100 shadow-sm" data-id="element-53">
            {/* Doc 1 */}
            <button onClick={() => onNavigate(3)} className="w-full flex items-center justify-between p-3 rounded-xl hover:bg-slate-50 transition-colors border border-transparent hover:border-slate-100" data-id="element-54">
              <div className="flex items-center gap-3" data-id="element-55">
                <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center" data-id="element-56">
                  <FileText className="w-5 h-5 text-datmont-blue" data-id="element-57" />
                </div>
                <div className="text-left" data-id="element-58">
                  <p className="text-sm font-bold text-datmont-900" data-id="element-59">
                    FBI Record
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-60">Issued: 03/12/2024</p>
                </div>
              </div>
              <span className="px-2.5 py-1 bg-green-50 text-datmont-green text-[10px] font-bold uppercase tracking-wider rounded-md border border-green-100" data-id="element-61">
                Verified
              </span>
            </button>

            {/* Doc 2 */}
            <button onClick={() => onNavigate(3)} className="w-full flex items-center justify-between p-3 rounded-xl hover:bg-slate-50 transition-colors border border-transparent hover:border-slate-100" data-id="element-62">
              <div className="flex items-center gap-3" data-id="element-63">
                <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center" data-id="element-64">
                  <FileText className="w-5 h-5 text-datmont-blue" data-id="element-65" />
                </div>
                <div className="text-left" data-id="element-66">
                  <p className="text-sm font-bold text-datmont-900" data-id="element-67">
                    Birth Certificate
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-68">Issued: 01/08/2023</p>
                </div>
              </div>
              <span className="px-2.5 py-1 bg-green-50 text-datmont-green text-[10px] font-bold uppercase tracking-wider rounded-md border border-green-100" data-id="element-69">
                Verified
              </span>
            </button>

            {/* Doc 3 */}
            <button className="w-full flex items-center justify-between p-3 rounded-xl hover:bg-slate-50 transition-colors border border-transparent hover:border-slate-100" data-id="element-70">
              <div className="flex items-center gap-3" data-id="element-71">
                <div className="w-10 h-10 rounded-lg bg-orange-50 flex items-center justify-center" data-id="element-72">
                  <Clock className="w-5 h-5 text-orange-500" data-id="element-73" />
                </div>
                <div className="text-left" data-id="element-74">
                  <p className="text-sm font-bold text-datmont-900" data-id="element-75">
                    Marriage Certificate
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-76">Issued: 06/15/2022</p>
                  <p className="text-[10px] text-orange-500 mt-0.5" data-id="element-77">
                    Valid Until: 06/15/2025
                  </p>
                </div>
              </div>
              <span className="px-2.5 py-1 bg-orange-50 text-orange-600 text-[10px] font-bold uppercase tracking-wider rounded-md border border-orange-100" data-id="element-78">
                Expiring Soon
              </span>
            </button>
          </div>
        </div>

        <button onClick={() => onNavigate(4)} className="w-full py-3.5 bg-datmont-900 text-white text-sm font-medium rounded-xl flex items-center justify-center gap-2 shadow-md hover:bg-datmont-800 transition-colors" data-id="element-79">
          <Plus className="w-4 h-4" data-id="element-80" /> Submit for Verification
        </button>

        {/* Quick Stats */}
        <div data-id="element-81">
          <h2 className="text-sm font-bold text-datmont-900 mb-3" data-id="element-82">
            Quick Stats
          </h2>
          <div className="grid grid-cols-2 gap-3" data-id="element-83">
            <div className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm flex flex-col items-center justify-center text-center" data-id="element-84">
              <span className="text-2xl font-bold text-datmont-900 mb-1" data-id="element-85">
                3
              </span>
              <span className="text-xs text-slate-500" data-id="element-86">
                Documents
                <br data-id="element-87" />
                Verified
              </span>
            </div>
            <div className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm flex flex-col items-center justify-center text-center" data-id="element-88">
              <span className="text-2xl font-bold text-datmont-900 mb-1" data-id="element-89">
                1
              </span>
              <span className="text-xs text-slate-500" data-id="element-90">
                Expiring Soon
                <br data-id="element-91" />
                Action Needed
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Nav */}
      <div className="absolute bottom-0 inset-x-0 h-20 bg-white border-t border-slate-100 flex items-center justify-around px-6 pb-4" data-id="element-92">
        <button className="flex flex-col items-center gap-1 text-datmont-blue" data-id="element-93">
          <Home className="w-6 h-6" data-id="element-94" />
          <span className="text-[10px] font-medium" data-id="element-95">Home</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-slate-400 hover:text-slate-600" data-id="element-96">
          <FileText className="w-6 h-6" data-id="element-97" />
          <span className="text-[10px] font-medium" data-id="element-98">Documents</span>
        </button>
        <button onClick={() => onNavigate(6)} className="flex flex-col items-center gap-1 text-slate-400 hover:text-slate-600" data-id="element-99">
          <Activity className="w-6 h-6" data-id="element-100" />
          <span className="text-[10px] font-medium" data-id="element-101">Activity</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-slate-400 hover:text-slate-600" data-id="element-102">
          <User className="w-6 h-6" data-id="element-103" />
          <span className="text-[10px] font-medium" data-id="element-104">Profile</span>
        </button>
      </div>
    </div>;
}